import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as $ from 'jquery';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridOptions } from "ag-grid/main";

import {
  AgGridUtility,
  APP_DATE_FORMAT,
  AUDIT_ENTITY_COLUMN_DEFS,
  AUDIT_ENTITY_ID,
  AUDIT_ENTITY_TYPE,
  AUDIT_PAGE_TITLE,
  CommonUtility,
  DataService,
  DateUtility,
  DOUBLE_ROW_HEADER,
  EDIT_BTN,
  AUDIT_BTN,
  FROMDT_GT_TODT,
  MIN_CHAR_SEARCH_LENGTH,
  OVERDUE_BTN, Role,
  ServerConstantsService,
  SINGLE_ROW_HEADER,
  Task,
  TaskHistory,
  TaskSearch,
  WpPerson,
  WpProvider,
  WpReferral
} from '../shared';
import { Subject } from 'rxjs';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { ProviderService } from "../provider-management/provider-management.service";
import {LoaderComponent} from '../loader/loader.component';

export type EntityResponseType = HttpResponse<Task>;


@Component({
    selector: 'app-task-summary',
    templateUrl: './task-summary.component.html',
    styleUrls: ['./task-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class TaskSummaryComponent implements OnInit {
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;
  searchCriteria: string;
  currentSearch: String;
  noData: Boolean = false;
  task: Task;
  tasks: Task[] =[];
  taskHistory: TaskHistory[];
  programs: any[];
  taskStatus: any[];
  taskTypes: any[];
  private _danger = new Subject<string>();
  errorMessage: string;
  programMap: any;
  taskStatusMap: any;
  taskTypesMap: any;
  serverConstants: any;
  userActionNotificationsMap: any;
  elasticSuggestions = new BehaviorSubject<any>(null);
  elasticSuggestionsUser = new BehaviorSubject<any>(null);
  results: any = [];
  suggestions: any = [];
  suggestionsUser: any = [];
  taskSearch: TaskSearch;
  taskDueDateFrom: any;
  taskDueDateTo: any;
  APP_DATE_FORMAT = APP_DATE_FORMAT;
  modalReference: any;
  closeResult: string;
  noHistoryData: Boolean = false;
  historyTasks: Task[] = [];
  firstHistoryTask: Task;
  completeTaskYes: Boolean = false;
  completeTaskNo: Boolean = false;
  reAssignYes: Boolean = false;
  reAssignNo: Boolean = false;
  workers: any[];
  reAssignedWorker: string;
  isSubmitEnabled: Boolean = false;
  isTaskOpen: Boolean = false;
  isTaskInprogress: Boolean = false;
  minDate: any;
  errorEndDateField: string = null;
  assignedTo: any;
  county: any;
  columnDefs: any;
  auditColumnDefs: any;
  context: any;
  taskTypesJson: any;
  taskStatusJson: any;
  countiesJson: any;
  countiesMap: any;
  counties: any;

  countiesDropdown: any[] = [];

  assignedToJson: any;
  assignedToMap: any;
  assignedToDD: any;
  providers: Map<any, string> = new Map<any, string>();
  columnDefsIndv: any;
  programsJson: any;
  gridOptions: GridOptions;
  gridApi;
  gridApiIndv;

  dropdownSettings: any = {};
  taskStatusMulti: Array<any>;

  valArray: any[];
  // SSN Search
  ssnValue;

  userCounties: any;
  countiesArr: Array<any> = [];
  sharedData: any;
  isFocused = false;
  tabToNextCell: any;
  referralId: any;
  wpPersonId: any;


  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('taskStartDtDp') taskStartDtDp: ElementRef;
  @ViewChild('resultList') resultList: ElementRef;
  @ViewChild('searchInput') searchInput: ElementRef;

  assignedUser: any;
  isStateWorker = true;
  roles: Role[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private titleService: Title,
    private modalService: NgbModal,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private providerService: ProviderService,
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    if (this.dataService.getSharedDataObject().get('CRTSK') === undefined) {
      this.router.navigate(['/task']);
    }
  }



  ngOnInit() {

    this.sharedData = this.dataService.getSharedDataObject();
    /*this.countiesArr = this.sharedData.get('userCounties');
    if (this.countiesArr === undefined) {
      this.countiesArr = JSON.parse(sessionStorage.getItem('userCounties'));
    }
    sessionStorage.setItem('userCounties', JSON.stringify(this.countiesArr));
    
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false,
    };
    this.dataService.removeValueFromSharedDataMap('selectedEPForComponent');
    this.taskStatusMulti = [];

    //Remove reference from latest Appointment task, in case it is still there
    this.dataService.removeValueFromSharedDataMap('appTaskId');
    this.dataService.removeValueFromSharedDataMap('UNIVERSE_SEARCH');
    this.searchCriteria = 'all';
    
    this.task.programCd = 'FS';
    this.taskSearch = new TaskSearch();

    if (this.dataService.getSharedDataObject().get('initTaskSearchSw') === 'Y') {
      this.initializeSearch();
    }*/
    this.getRefTableData();
    this.task = new Task();
    this.getColumnDefinitions();
    this.getAuditColumnDefs();

    /*this.providers = this.dataService.getSharedDataObject().get('providers');
    if (this.providers === null || this.providers === undefined || this.providers.size === 0) {
      this.loadProviders();
    }

    this.roles = this.sharedData.get('roles');
    this.setAssignedUserAccess();*/
    //this.taskSearch = this.dataService.getSharedDataObject().get('taskSearch');
    this.taskSearch = new TaskSearch();
    this.wpPersonId = this.sharedData.get('wpPersonId'); 
    this.referralId = this.sharedData.get('referralId');
    this.taskSearch.task = new Task();
    this.taskSearch.task.wpPerson = new WpPerson();
    this.taskSearch.task.wpReferral = new WpReferral();
    this.taskSearch.task.wpPerson.id = this.wpPersonId;
    this.taskSearch.task.wpReferral.id = this.referralId;
    this.search();
  }

  /*setAssignedUserAccess() {
    this.isStateWorker = true;
    for (const role of this.roles) {
      if (role.id === 5) {
        this.isStateWorker = false;
        break;
      }
    }
  }
  ssnSearch() {

    if (this.ssnValue !== undefined && this.ssnValue.length === 9) {
      this.dataService.addValueToSharedDataMap('SSN_SEARCH', this.ssnValue);
      this.dataService.addValueToSharedDataMap('UNIVERSE_SEARCH', true);
      this.router.navigate(['/universe/personSummary']);
    } else {
      this.notificationService.error('Universe Search', "Please provide valid SSN");
    }

  }*/

  focus() {
    this.isFocused = true;
  }

  /*onSelectAll(items: any) {
    for (let item of items) {
      this.onItemSelect(item);
    }
    this.isFocused = false;
  }


  onItemDeselect(deselectStatus) {

    this.taskStatusMulti.forEach((status, index) => {
      if (status === deselectStatus) this.taskStatusMulti.splice(index, 1);
    });
    event.stopPropagation();
  }

  onItemSelect(item: any) {
    this.isFocused = false;
  }*/

  getColumnDefinitions() {
    this.columnDefs = [
       /*{
         headerName: 'Task ID',
         field: '',
         cellRenderer: this.getTaskIdAudit,
      //   cellStyle: {'text-align': 'center !important'},
         width: 100,
       },*/
      {

        headerName: 'Task Type',
        field: '',
        refData: this.taskTypesJson,
        cellRenderer: this.getTaskTypeLink,
        width: 240,
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
        valueGetter: this.getTaskType,
      }
      ,
      {
        headerName: 'Client Name',
        colId: "wpPerson.firstName&wpPerson.lastName",
        valueGetter: function getName(params) {
          return params.data.wpPerson.firstName + ' ' + params.data.wpPerson.lastName;
        },
        width: 150,
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
        suppressFilter: false,
      },
      {
        headerName: 'Creation Date',
        field: 'createdDate',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 120,
      },
      {
        headerName: 'Due Date',
        field: 'taskDueDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatDates,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 115,
      },
      {
        headerName: 'Completion Date',
        field: 'taskCompletionDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatDates,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 130,
      },
      {
        headerName: 'Assigned To',
        field: 'assignedTo',
        width: 110,
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
        valueGetter: this.getAssignedTo,
      },
      {
        headerName: 'County',
        field: '',
        width: 120,
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
        valueGetter: this.getServiceCounty,
      },
      {
        headerName: 'Task Status',
        field: 'taskStatus',
        refData: this.taskStatusJson,
        width: 100,
        autoHeight: true,
        cellStyle: { 'white-space': 'normal' },
      },
      {
        headerName: 'Overdue',
        field: '',
        cellRenderer: this.isTaskOverDue,
        // cellStyle: {'text-align': 'center !important'},
        width: 104,
        suppressFilter: true,
        suppressSorting: true,
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        // cellStyle: {'text-align': 'center !important'},
        width: 90,
        suppressFilter: true,
        suppressSorting: true,
      },
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if ( nextCell == null || nextCell.column.colDef.headerName === 'Action' ||
        nextCell.column.colDef.headerName === 'Task ID' || nextCell.column.colDef.headerName === 'Task Type') {
        return;
      } else {
        return nextCell;
      }
    };

    this.context = {
      component: this,
    };
  }
     getTaskIdAudit(params) {
     const that = params.context.component;
     const element = document.createElement('p');
     element.innerHTML = params.data.id;
     return element;
   }
   createNew(){
     this.router.navigate(['task/summary/create']);
   }

  getAuditColumnDefs() {
    this.auditColumnDefs = [
      {
        headerName: 'Task ID',
        field: 'id',
        tooltipField: 'id'
      },
      {
        headerName: 'Task Type',
        field: 'taskType',
        refData: this.taskTypesJson,
        tooltip: (params) => {
          const taskTypesMap = params.context.taskTypesJson;
          const taskTypeCode = params.data.taskType;
          const taskType = taskTypesMap[taskTypeCode];
          return taskType;
        }
      },
      {
        headerName: 'Task Status',
        field: 'taskStatus',
        refData: this.taskStatusJson,
        tooltip: (params) => {
          const taskStatusMap = params.context.taskStatusJson;
          const taskStatusCode = params.data.taskStatus;
          const taskStatus = taskStatusMap[taskStatusCode];
          return taskStatus;
        }
      },
      {
        headerName: 'Modified By',
        field: 'createdBy',
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'lastModifiedDate',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      }
    ];
  }

  getTaskType(params) {
    const task: Task = params.data;
    const that = params.context.component;

    return that.taskTypesMap.get(task.taskType);
  }

  getAssignedTo(params) {
    const task: Task = params.data;
    const that = params.context.component;

    if (task.assignedToInd === "C") {
      return task.assignedUserStr;
    } else if (task.assignedToInd === "P") {
      return that.providers.get(task.assignedTo);
    }
  }

  getServiceCounty(params) {
    const task: Task = params.data;
    const that = params.context.component;

    return that.countiesMap.get(task.serviceCounty + '');
  }

  getEditButton(params) {
    const that = params.context.component;
    const divRow = document.createElement('div');
    divRow.setAttribute("class", "row");

    // Edit Button
    const element = document.createElement('a');
    const image = EDIT_BTN;

    //element.className = 'edit-button';
    element.innerHTML = image;
    element.addEventListener('click', () => {
      //that.setInitSearchCriteria();
      that.dataService.addValueToSharedDataMap('referralId', params.data.wpReferral.id);
      that.dataService.addValueToSharedDataMap('wpPersonId', params.data.wpPerson.id);
      that.dataService.addValueToSharedDataMap('task', params.data);
      that.router.navigate(['/task/createTask']);
    });

    // START ADA
    element.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.dataService.addValueToSharedDataMap('referralId', params.data.wpReferral.id);
        that.dataService.addValueToSharedDataMap('wpPersonId', params.data.wpPerson.id);
        that.dataService.addValueToSharedDataMap('task', params.data);
        that.router.navigate(['/task/createTask']);
      }
      else if(event.keyCode == 9){
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }
    });
    element.setAttribute("tabindex", "0");
    // END ADA

    const divCol1 = document.createElement('div');
    divCol1.setAttribute("class", "col-2 right-margin-1");

    divCol1.appendChild(element);

    // Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.TasksEntity');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Task History');
      that.getUserInfoForTaskId(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
      // Pass Floating Elements here...
      // that.dataService.addValueToSharedDataMap('floatingData', that.auditElements);
    });

    // START ADA
    auditElement.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.TasksEntity');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Task History');
        that.getUserInfoForTaskId(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
      }
      else {
        return;
      }
    });
    auditElement.setAttribute("tabindex", "0");
    // END ADA

    const divCol2 = document.createElement('div');
    divCol2.setAttribute("class", "col-1");
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);

    return divRow;
  }

  getTaskTypeLink(params) {
    const that = params.context.component;
    const taskTypeName = that.convertCode(that.taskTypesMap, params.data.taskType);

    if (params.data.taskStatus === 'CO') {
      const element = document.createElement('div');
      element.innerHTML = taskTypeName;
      element.setAttribute("tabindex", "0");
      return element;

    } else {
      const element = document.createElement('a');
      element.innerHTML = taskTypeName;
      element.addEventListener('click', () => {
        that.updateTaskStatus(params.data);
        that.routeSelection(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
      });

      // START ADA
      element.addEventListener('keydown', (event) => {
        if (event.keyCode === 13 || event.keyCode === 32) {
          that.updateTaskStatus(params.data);
          that.routeSelection(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
        }
        else {
          return;
        }
      });
      element.setAttribute("tabindex", "0");
      // END ADA
      return element;
    }
  }

    isTaskOverDueForPDF(params) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateParts = params.taskDueDt.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const taskDueDt = new Date(year, month, day);
    const icon = OVERDUE_BTN;
    let element = null;

    if (params.data.taskStatus !== "CO"
      && today > taskDueDt) {
      element = document.createElement('span');
      element.innerHTML = icon;
      return element;
    } else {
      return null;
    }
  }
  isTaskOverDue(params) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateParts = params.data.taskDueDt.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const taskDueDt = new Date(year, month, day);
    const icon = OVERDUE_BTN;
    let element = null;

    if (params.data.taskStatus !== "CO"
      && today > taskDueDt) {
      element = document.createElement('span');
      element.innerHTML = icon;
      return element;
    } else {
      return null;
    }
  }

  getRefTableData() {
    console.log('task list 1');
    /*this.programs = this.data.getValueFromSharedDataMap("PROGRAMS");
    this.taskStatus = this.data.getValueFromSharedDataMap('TASKSTATUS');
    this.taskTypes = this.data.getValueFromSharedDataMap('TASKTYPES');
    this.counties = this.data.getValueFromSharedDataMap('COUNTIES');
    this.assignedToDD = this.data.getValueFromSharedDataMap('ASSIGNEDTO');*/
    if (this.data.getValueFromSharedDataMap("PROGRAMS") !== undefined) {
      this.programs = this.data.getValueFromSharedDataMap("PROGRAMS");
      this.taskStatus = this.data.getValueFromSharedDataMap('TASKSTATUS');
      this.taskTypes = this.data.getValueFromSharedDataMap('TASKTYPES');
      this.counties = this.data.getValueFromSharedDataMap('COUNTIES');
      this.assignedToDD = this.data.getValueFromSharedDataMap('ASSIGNEDTO');
      sessionStorage.setItem("programs", JSON.stringify(this.programs));
      sessionStorage.setItem("taskStatus", JSON.stringify(this.taskStatus));
      sessionStorage.setItem("taskTypes", JSON.stringify(this.taskTypes));
      sessionStorage.setItem("counties", JSON.stringify(this.counties));
      sessionStorage.setItem("assignedToDD", JSON.stringify(this.assignedToDD));
    }
    else {
      this.programs = JSON.parse(sessionStorage.getItem('programs'));
      this.taskStatus = JSON.parse(sessionStorage.getItem('taskStatus'));
      this.taskTypes = JSON.parse(sessionStorage.getItem('taskTypes'));
      this.counties = JSON.parse(sessionStorage.getItem('counties'));
      this.assignedToDD = JSON.parse(sessionStorage.getItem('assignedToDD'));
    }

    this.programMap = this.commonUtil.createMapFromList(this.programs);
    this.taskStatusMap = this.commonUtil.createMapFromList(this.taskStatus);
    this.taskTypesMap = this.commonUtil.createMapFromList(this.taskTypes);
    this.countiesMap = this.commonUtil.createMapFromList(this.counties);
    this.assignedToMap = this.commonUtil.createMapFromList(this.assignedTo);

    this.programsJson = this.commonUtil.createNativeMapFromList(this.programs);
    this.taskTypesJson = this.commonUtil.createNativeMapFromList(this.taskTypes);
    this.taskStatusJson = this.commonUtil.createNativeMapFromList(this.taskStatus);
    this.countiesJson = this.commonUtil.createNativeMapFromList(this.counties);
    this.assignedToJson = this.commonUtil.createNativeMapFromList(this.assignedTo);

    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    //this.loadCounties();
  }


  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }

  getUserInfoForTaskId(task, referralId, wpPersonId) {
    this.dataService.addValueToSharedDataMap('referralId', referralId);
    this.dataService.addValueToSharedDataMap('wpPersonId', wpPersonId);
    this.http.post<any>(this.serverConstants.COMMON_SERVER_API_URL + "/personsummary/personEnrollmentSummary",
      { "referralId": Number(referralId), "personId": Number(wpPersonId) })
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res === null || res === undefined) {
            this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          } else {
            const personEnrollmentSummary: any = res;

            if (personEnrollmentSummary.etEnrollment !== null) {

              if (personEnrollmentSummary.etEnrollment.enrollmentEndDt != null) {
                this.dataService.makeAllPagesReadyIfCaseClosed();
              } else {
                this.dataService.revertReadOnlyChanges();
                this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
              }

              this.dataService.addValueToSharedDataMap("etEnrollment", personEnrollmentSummary.etEnrollment);
            }
            if (personEnrollmentSummary.personProvider !== null) {
              this.dataService.addValueToSharedDataMap("personProvider", personEnrollmentSummary.personProvider);
            }

            this.router.navigate(['/task/taskSummary/auditHistory']);
          }
        },
        response => {
          this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }

  updateTaskStatus(task) {
    if (task.taskStatus !== 'OP') {
      return;
    }

    this.http.post<any>(this.serverConstants.SERVER_API_URL + '/tasks/mark-as-inProgress',
      /*{'taskId': Number(task.id)}*/task.id)
      .subscribe(
        (res: HttpResponse<any>) => {

        },
        response => {
          this.notificationService.error('Task', this.userActionNotificationsMap.ERROR + ' There was an error while updating the task status.');
        },
        () => {
        });
  }

  routeSelection(task, referralId, wpPersonId) {
    //this.setInitSearchCriteria();
    this.dataService.addValueToSharedDataMap('referralId', referralId);
    this.dataService.addValueToSharedDataMap('wpPersonId', wpPersonId);
    console.log('task.summary.component - routeSelection - task.taskType ========== '+task.taskType);
    if (task.taskType === "RR") {

      this.http.post<WpPerson>(this.serverConstants.COMMON_SERVER_API_URL + '/persondata/load', wpPersonId).subscribe(
        (data: WpPerson) => {
          if (data !== undefined && data.ssn !== undefined) {
            this.dataService.addValueToSharedDataMap('SSN_SEARCH', data.ssn);
            this.dataService.addValueToSharedDataMap('UNIVERSE_SEARCH', true);
            this.navigateRoute(task);
          }

        }, response => {
          //Display Toast Error Notification
          this.notificationService.error('Person', this.userActionNotificationsMap.ERROR);
        }, () => {
        })
    }
    else {
      this.http.post<any>(this.serverConstants.COMMON_SERVER_API_URL + "/personsummary/personEnrollmentSummary",
        { "referralId": Number(referralId), "personId": Number(wpPersonId) })
        .subscribe(
          (res: HttpResponse<any>) => {
            if (res === null || res === undefined) {
              this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
            } else {
              const personEnrollmentSummary: any = res;

              if (personEnrollmentSummary.etEnrrolment !== null) {
                if (personEnrollmentSummary.etEnrollment.enrollmentEndDt != null) {
                  this.dataService.makeAllPagesReadyIfCaseClosed();
                } else {
                  this.dataService.revertReadOnlyChanges();
                  this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
                }
                this.dataService.addValueToSharedDataMap("etEnrollment", personEnrollmentSummary.etEnrollment);
              }
              if (personEnrollmentSummary.personProvider !== null) {
                this.dataService.addValueToSharedDataMap("personProvider", personEnrollmentSummary.personProvider);
              }
              this.navigateRoute(task);
            }
          },
          response => {
            this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          },
          () => {
          });
    }
  }

  navigateRoute(task) {
    switch (task.taskType) {
      case 'RF': {  // Referral
        this.router.navigate(['task/contactSummary']);
        break;
      }
      case 'AP': {  // Referral
        this.dataService.addValueToSharedDataMap('appTaskId', task.id);
        this.router.navigate(['/task/appointment']);
        break;
      }
      case 'CA': {  // Referral
        this.router.navigate(['/task/appointment']);
        break;
      }
      case 'PA': {  // Perform Assessment
        this.router.navigate(['task/assessmentSummary']);
        break;
      }
      case 'CN':  // Client Not Longer RTW
      case 'CC':  // Case Closure
      case 'CD':  // Client Dropped from SNAP Case
      case 'ER':  // Employment Plan Annual Review
      case 'EP': {  // Employment Plan
        this.dataService.addValueToSharedDataMap('taskId', task.id);
        this.router.navigate(['task/employmentPlanSummary']);
        break;
      }
      case 'CM':  // Component
      case 'CU': {  // Component Updates
        this.router.navigate(['task/componentSummary']);
        break;
      }
      case 'MT': {  // Monthly Track Component
        this.router.navigate(['task/componentSummary/trackComponent']);

        break;
      }
      case 'PR': {  // Provider Reassigment
        this.router.navigate(['task/personSummary/enrollmentSummary']);
        break;
      }
      case 'CE':
      case 'CG':
      case 'GQ':
      case 'DG':
      case 'NC':  // Non Compliance
      case 'GR':  // Good Cause Request
      case 'GD': {  // Good Cause Decision
        this.router.navigate(['/task/noncomplianceSummary']);
        break;
      }
      case 'ED': {  // Exemption Decision
        this.router.navigate(['/task/noncomplianceSummary']);
        break;
      }
      case 'PR': {  // Provider Reassignment
        this.router.navigate(['task/personSummary']);
        break;
      }
      case 'DU':{
        this.router.navigate(['task/correspondence']);
        break;
      }
      case 'AC':  // Address Change
      case 'WR':  // Work Registration Exemption
      case 'ND':  // Non Compliance Decision
      case 'EX':  // Exemption Request
      case 'AR':  // Activity Recommendation
      case 'RR': {  // Reverse Referral
        this.dataService.addValueToSharedDataMap('task', task);
        this.router.navigate(['/universe/create']);
        break;
      }
      case 'ET':
      case 'OT': 
      case 'OS': {  // Reverse Referral
        this.dataService.addValueToSharedDataMap('task', task);
        this.router.navigate(['/task/createTask']);
        break;
      }
      case 'RQ':  // Reimbursement Request
      case 'RE':  //  Reimbursement Return for Revision (Actionable)
      case 'OP': {
        this.router.navigate(['/task/reimbursementsSummary/reimbursements']);
        break;
      }
      case 'RP':  //  Reimbursement Paid (Informational)
      case 'RA':
         {  //  Reimbursement Decision
        this.router.navigate(['/task/reimbursementsSummary']);
        break;
      }
      case 'RR': {  // Reverse Referral
        this.router.navigate(['/universe/personSummary']);
        break;
      }
      case 'EC': {  // Employment Change
        this.router.navigate(['task/assessmentSummary']);
        break;
      }
      case 'TC': {  // Contact Change
        this.router.navigate(['task/personSummary']);
        break;
      }
    }
  }

  search() {
    setTimeout(() => this.modalService.open(LoaderComponent, {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'loaderBackdrop',
      windowClass: '3'
    }), 0);
    this.http.post<TaskSearch>(this.serverConstants.SERVER_API_URL + '/tasks/search', this.taskSearch).subscribe(
      (val) => {
        setTimeout(() => {
          $('ngb-modal-window.3:visible').remove();
          $('ngb-modal-backdrop:visible').remove();
        }, 0);
        if (val == null || val.hasOwnProperty('errorCode')) {
          this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          setTimeout(() => this.taskStartDtDp.nativeElement.focus(), 0);
          this.taskStartDtDp.nativeElement.click();
          return;
        }
        this.taskSearch = val;

        if (this.taskSearch.taskDueDateFrom != null) {
          this.taskDueDateFrom = this.dateUtil.convertDateFromServer(this.taskSearch.taskDueDateFrom);
        }

        if (this.taskSearch.taskDueDateTo != null) {
          this.taskDueDateTo = this.dateUtil.convertDateFromServer(this.taskSearch.taskDueDateTo);
        }
        if (this.taskSearch.tasks !== null && this.taskSearch.tasks.length > 0) {
          this.tasks = this.taskSearch.tasks;
          this.noData = false;
        } else {
          this.tasks = undefined;
          this.noData = true;
        }
      },
      response => {
        this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    setTimeout(function() {
      params.api.resetRowHeights();
    }, 0);
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else {
      this.gridApi.sizeColumnsToFit();
      this.gridApiIndv.sizeColumnsToFit();
    }
  }

  ngOnDestroy() {
    this.taskStatusMulti = [];
  }


  closeFix(event, datePicker) {
    if (event.target.offsetParent == null)
      datePicker.close();
    else if (event.target.offsetParent.nodeName != "NGB-DATEPICKER")
      datePicker.close();
  }

  /* For Task Search */

  /* For Individual Search*/



  focusNextFromIndvSearch(e) {
    if (!this.noData) {
      if (this.suggestions !== null && this.suggestions !== undefined && this.suggestions.length > 0) {
        this.addEventListenerToIndvSearch(e);
      } else {
        if (e.keyCode === 9 && !e.shiftKey && !this.noData) {
          e.preventDefault();
          setTimeout(() => this.headerText.nativeElement.focus(), 0);
          this.headerText.nativeElement.click();
        }
      }
    } else {
    }
  }

  focusSearchInput(e){
      setTimeout(() => this.searchInput.nativeElement.focus(), 0);
  }


  addEventListenerToIndvSearch(event) {
    var tabKeyCode = 9;
    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.results.length === 0) {
      return;
    }
    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }
    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndexIndv();
  }

  setDisplayedRowAtIndexIndv() {
    // get the first row
    var rowNode = this.gridApiIndv.getDisplayedRowAtIndex(0);
    // scrolls to the first row
    //this.gridApiIndv.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApiIndv.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApiIndv.setFocusedCell(0, firstCol);
  }


  /* For Task Search*/
  focusSearchSummary(e) {
    this.addEventListenerToButton(e);
  }

  focusIndividualSearch(e) {
    this.addEventListenerToButton(e);
  }

  addEventListenerToButton(event) {
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }

    if (this.tasks.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    if(this.tasks.length !== 0){
      var index = this.gridApi.getFirstDisplayedRow();
      var rowNode = this.gridApi.getDisplayedRowAtIndex(index);
  
      // scrolls to the first row
      //this.gridApi.ensureIndexVisible(0, 'top');
  
      // scrolls to the first column
      var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
      this.gridApi.ensureColumnVisible(firstCol);
  
      // sets focus into the first grid cell
      this.gridApi.setFocusedCell(index, firstCol);
    }

  }

  /* Go To Header*/

  focusing(event) {
    if (!event.shiftKey && event.keyCode == 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.gridApi) {
      this.setDisplayedRowAtIndex();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/task-summary/task-summary.component.ts